import React, { useState, useEffect } from 'react';
import api from '../utils/api';

const ACCENT = '#c88346';

// Super Admin only. Grant/revoke each manager's WRITE (create/update) and DELETE access to the
// discounts module. Viewing discounts stays open to all managers, so there's no "read" toggle.
function AccessControl() {
  const [managers, setManagers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [toast, setToast] = useState('');

  const load = async () => {
    setLoading(true); setError('');
    try {
      const r = await api.get('/manage/permissions');
      setManagers((r.data.managers || []).map(m => ({ ...m })));
    } catch (e) {
      setError(e.response?.data?.error || 'Failed to load managers');
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => { load(); }, []);

  const toggle = (username, field) =>
    setManagers(ms => ms.map(m => m.username === username ? { ...m, [field]: !m[field] } : m));

  const save = async () => {
    setSaving(true); setError(''); setToast('');
    try {
      await api.put('/manage/permissions', {
        grants: managers.map(m => ({ username: m.username, canWrite: !!m.canWrite, canDelete: !!m.canDelete })),
      });
      setToast('Permissions saved.');
      setTimeout(() => setToast(''), 3000);
    } catch (e) {
      setError(e.response?.data?.error || 'Failed to save');
    } finally {
      setSaving(false);
    }
  };

  const th = { padding: '10px 12px', textAlign: 'left', fontSize: '11px', fontWeight: 700, color: '#8b7d6e', textTransform: 'uppercase', letterSpacing: '0.3px' };
  const td = { padding: '10px 12px', fontSize: '13px', color: '#3d2b1f', borderBottom: '1px solid #f0e8dd' };

  return (
    <div style={{ padding: '24px', maxWidth: '860px', margin: '0 auto' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
        <h1 style={{ fontSize: '22px', fontWeight: 800, color: '#3d2b1f', margin: 0 }}>Discount Access Control</h1>
        <button onClick={save} disabled={saving || loading}
          style={{ padding: '9px 18px', background: `linear-gradient(135deg,${ACCENT} 0%,#b06e2f 100%)`, color: '#fff', border: 'none', borderRadius: '10px', fontSize: '13px', fontWeight: 700, cursor: saving || loading ? 'not-allowed' : 'pointer', opacity: saving || loading ? 0.6 : 1 }}>
          {saving ? 'Saving…' : 'Save Permissions'}
        </button>
      </div>
      <p style={{ fontSize: '13px', color: '#8b7d6e', marginTop: 0, marginBottom: '16px' }}>
        All managers can <strong>view</strong> discounts. Grant <strong>Create/Edit</strong> and <strong>Delete</strong> per manager below.
      </p>

      {error && <div style={{ background: '#fef2f2', color: '#dc2626', padding: '10px', borderRadius: '10px', marginBottom: '12px', fontSize: '13px' }}>{error}</div>}
      {toast && <div style={{ background: '#ecfdf5', color: '#059669', padding: '10px', borderRadius: '10px', marginBottom: '12px', fontSize: '13px' }}>{toast}</div>}

      <div style={{ background: '#faf7f3', borderRadius: '16px', border: '1px solid #ece0d1', overflow: 'hidden' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr style={{ borderBottom: '2px solid rgba(200,131,70,0.12)', background: '#fff' }}>
              <th style={th}>Manager</th>
              <th style={th}>Username</th>
              <th style={{ ...th, textAlign: 'center', width: '90px' }}>View</th>
              <th style={{ ...th, textAlign: 'center', width: '120px' }}>Create / Edit</th>
              <th style={{ ...th, textAlign: 'center', width: '90px' }}>Delete</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan={5} style={{ padding: '20px', textAlign: 'center', color: '#999' }}>Loading…</td></tr>
            ) : managers.length === 0 ? (
              <tr><td colSpan={5} style={{ padding: '20px', textAlign: 'center', color: '#999' }}>No managers found.</td></tr>
            ) : managers.map(m => (
              <tr key={m.username}>
                <td style={{ ...td, fontWeight: 700 }}>{m.name}</td>
                <td style={{ ...td, color: '#7a6b5d' }}>{m.username}</td>
                <td style={{ ...td, textAlign: 'center' }}>
                  <input type="checkbox" checked readOnly disabled title="All managers can view" style={{ cursor: 'not-allowed' }} />
                </td>
                <td style={{ ...td, textAlign: 'center' }}>
                  <input type="checkbox" checked={!!m.canWrite} onChange={() => toggle(m.username, 'canWrite')} style={{ cursor: 'pointer', width: '16px', height: '16px' }} />
                </td>
                <td style={{ ...td, textAlign: 'center' }}>
                  <input type="checkbox" checked={!!m.canDelete} onChange={() => toggle(m.username, 'canDelete')} style={{ cursor: 'pointer', width: '16px', height: '16px' }} />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default AccessControl;
